import ff from "../component/ff.png";
import tt from "../component/tt.png";
import yt from "../component/yt.png";
import git from "../component/git.png";
import ins from "../component/instagram.jpg";
function Footer() {
  return (
    <div className="footer-my">
      <div className="footer-my-content">
        <span>
          <a
            href="https://www.facebook.com/prasoon.kandel68"
            target="_blank"
            rel="noopener noreferrer">
            <img src={ff} className="logo-social-media" alt="F"></img>
          </a>
          <a
            href="https://www.youtube.com/@prasoonkandel"
            target="_blank"
            rel="noopener noreferrer">
            <img src={yt} className="logo-social-media" alt="F"></img>
          </a>
          <a
            href="https://www.tiktok.com/@prasoonkandel"
            target="_blank"
            rel="noopener noreferrer">
            {" "}
            <img src={tt} className="logo-social-media" alt="F"></img>
          </a>{" "}
          <a
            href="https://github.com/prasoonkandel"
            target="_blank"
            rel="noopener noreferrer">
            <img src={git} className="logo-social-media" alt="F"></img>
          </a>
          <a
            href="https://www.instagram.com/prasoonkandel/"
            target="_blank"
            rel="noopener noreferrer">
            <img src={ins} className="logo-social-media" alt="F"></img>
          </a>
        </span>
        <p>&copy; 2025 Prasoon Kandel. All rights reserved.</p>
      </div>
    </div>
  );
}

export default Footer;
